import { useMemo } from 'react'

import { DoughnutChart } from '@/components/charts/doughnut-chart'
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@/components/ui/card'
import { formatNumberWithCommas, getPercentValue } from '@/utils/helpers.ts'

import { SubscribedPieChart } from '../../../types'

interface ClaimedFansChartProps {
  subscribedPieChart: SubscribedPieChart
}

export const ClaimedFansChart = ({
  subscribedPieChart,
}: ClaimedFansChartProps) => {
  const conversionRate = useMemo(
    () =>
      getPercentValue(
        (subscribedPieChart?.subscribers || 0) /
          (subscribedPieChart?.clicks || 0),
      ),
    [subscribedPieChart],
  )

  return (
    <Card>
      <CardHeader>
        <CardTitle>Claimed Fans</CardTitle>
        <CardDescription>{conversionRate} Conversion Rate</CardDescription>
      </CardHeader>
      <CardContent>
        <div className="mx-auto h-full max-h-[200px] w-full max-w-[200px]">
          <DoughnutChart
            data={{
              labels: ['Claimed Fans', 'Rest'],
              datasets: [
                {
                  data: [
                    subscribedPieChart.subscribers,
                    subscribedPieChart.clicks - subscribedPieChart.subscribers,
                  ],
                  backgroundColor: ['#1BBFC2', '#F4F5F9'],
                },
              ],
            }}
            options={{
              plugins: {
                legend: {
                  display: false,
                },
              },
            }}
            toggleOptions={{
              hideLegend: true,
            }}
          />
        </div>
        <div className="mt-12 flex flex-col gap-4">
          <div className="flex items-center justify-between text-lg font-medium text-secondary-500 dark:text-white">
            <h5>Total Link Clicks</h5>
            <h5>{formatNumberWithCommas(subscribedPieChart.clicks)}</h5>
          </div>
          <div className="flex items-center justify-between font-medium leading-4 text-secondary-500 dark:text-white">
            <h5 className="flex items-center gap-2">
              <div className="h-3 w-3 rounded-full bg-[#1BBFC2]" />
              Claimed Fans
            </h5>
            <h5>{formatNumberWithCommas(subscribedPieChart.subscribers)}</h5>
          </div>
        </div>
      </CardContent>
    </Card>
  )
}
